export class SnapshotsSummaryResponse {
    'totalCount';
    'nativeSnapshotCount';
    'oldestSnapshot';
    'latestSnapshot';
    'snapshotsPerVault';
    'clusterTotalCount';
    'clusterOldestSnapshot';
    'clusterLatestSnapshot';
    'years';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nativeSnapshotCount",
            "baseName": "nativeSnapshotCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "oldestSnapshot",
            "baseName": "oldestSnapshot",
            "type": "SnapshotReference",
            "format": ""
        },
        {
            "name": "latestSnapshot",
            "baseName": "latestSnapshot",
            "type": "SnapshotReference",
            "format": ""
        },
        {
            "name": "snapshotsPerVault",
            "baseName": "snapshotsPerVault",
            "type": "Array<VaultSnapshotCount>",
            "format": ""
        },
        {
            "name": "clusterTotalCount",
            "baseName": "clusterTotalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "clusterOldestSnapshot",
            "baseName": "clusterOldestSnapshot",
            "type": "SnapshotReference",
            "format": ""
        },
        {
            "name": "clusterLatestSnapshot",
            "baseName": "clusterLatestSnapshot",
            "type": "SnapshotReference",
            "format": ""
        },
        {
            "name": "years",
            "baseName": "years",
            "type": "Array<YearlySnapshotDistribution>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotsSummaryResponse.attributeTypeMap;
    }
    constructor() {
    }
}
